import { Skeleton } from '@mui/material'
import React from 'react'

import Box from '../../../Theme/Box'

const SearchUserSkeleton = () =>
  [...Array(3).keys()].map((value) => (
    <Box
      key={value}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
      >
        <Skeleton
          animation="wave"
          variant="circular"
          width={60}
          height={60}
        />
        <Skeleton
          variant="text"
          height={30}
          width={200}
        />
      </Box>
      <Skeleton
        variant="primary"
        height={30}
        width={67}
      />
    </Box>
  ))

export default SearchUserSkeleton
